import React from 'react'
import { Tooltip } from 'antd';


function BlogCard({ imageUrl }) {
    
    return (
        
        <div className="w-full py-2 my-4">
            <a href="#">
                <div className="bg-white shadow rounded-lg hover:shadow-lg overflow-hidden">
                    <div className="bg-cover bg-center h-56 p-2" style={{backgroundImage: `url(${imageUrl})`}}>
                    
                    </div>
                    <div className="p-3">
                        <p className="font-bold text-gray-700 flex">
                            <span className="tracking-wide hover:text-purple-700"> Mahindra Tractor Hits "Highest Ever July sales", growth of 28% over last year</span>
                        </p>
                        {/* <p className="text-gray-700">742 Evergreen Terrace</p> */}
                    </div>
                    
                    <div className="px-4 pb-4">
                        <div className="">
                            <button className="px-3 py-2 w-full rounded items-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 text-xs hover:bg-purple-700 hover:text-white">
                                <span className="uppercase tracking-wider">Read More</span>
                            </button>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
}

export default BlogCard;
